import { render, staticRenderFns } from "./minMaxAging.vue?vue&type=template&id=326cd976"
import script from "./minMaxAging.vue?vue&type=script&lang=js"
export * from "./minMaxAging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports